import { useTranslation } from "react-i18next";
import {useNavigate, useOutletContext} from "react-router-dom";
import React, {useEffect, useState} from "react";
import { RiderProfileLayoutContextInterface } from "../RiderProfileLayout";
import ImageInput from "../../../Components/ImageInput";
import {patrollerService} from "../../../Api/Services/PatrollerService";
import {useLoading} from "../../../Context/LoadingProvider";
import RadioBtn from "../../../Components/RadioBtn";

const VehicleVerificationStep: React.FunctionComponent<any> = ({setStep,setProgressStep,needsVehicleCheck}) => {
    const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    setSubTitle,
      rider,
  } = useOutletContext<RiderProfileLayoutContextInterface>();
    const { startLoading, finnishLoading } = useLoading();
  const [isRealLicense, setIsRealLicense] = useState<boolean | undefined>(undefined);
  const [licenseImage, setLicenseImage] = useState<File[]>([]);

  const [licensePlate, setLicensePlate] = useState<string|null>(null);
  const [correctLicensePlateImage, setCorrectLicensePlateImage] = useState<File[]>([]);

  const [showRealLicensePlateFields, setShowRealLicensePlateFields] = useState<boolean>(false);

  const [showErrorMessages, setShowErrorMessages] = useState<boolean>(false);
    const [displayFakeIdMessage, setDisplayFakeIdMessage] = useState<boolean>(false);

  useEffect(() => {
    setSubTitle();
  }, [t, setSubTitle]);

  setSubTitle(t('Action'));

    useEffect(() => {
        
        if(needsVehicleCheck < 0){
            setStep((prev: number) => prev + 1);
            setProgressStep((prev: number) => prev + 1);
        }
        

        if (!rider.licensePlate){
            setShowRealLicensePlateFields(true);
        }
        //eslint-disable-next-line
    }, []);

    const handleNext = () => {
        if ((isRealLicense === undefined && rider.licensePlate) && needsVehicleCheck === 1) {
            setShowErrorMessages(true);
            return;
        }
        if (needsVehicleCheck === 1 && showRealLicensePlateFields && !licensePlate) {
            setShowErrorMessages(true);
            return;
        }

        if (!isRealLicense && !showRealLicensePlateFields) {
            setDisplayFakeIdMessage(true);
            setTimeout(() => {
                setShowRealLicensePlateFields(true);
            }, 1000);
            return;
        }

        if (isRealLicense === false && showRealLicensePlateFields && !licensePlate) {
            return;
        }

        startLoading('vehicle-verification');
        patrollerService.saveVehicleStepCheckForRider(rider.riderId, isRealLicense ?? true, licensePlate,licenseImage[0] ?? undefined, correctLicensePlateImage[0] ?? undefined)?.then(() => {
            setLicensePlate(null);
            setCorrectLicensePlateImage([]);
            setShowRealLicensePlateFields(false);
            setStep((prev: number) => prev + 1);
            setProgressStep((prev: number) => prev + 1);
        }).finally(() => {
            finnishLoading('vehicle-verification');
        });
    }

  return (
      <>
          {showRealLicensePlateFields ? <>
            
            <div className="mb-1 heading">
              {t("What’s the Rider vehicle plate number?")}
            </div>

            <div className="text-light mb-4">{t("Please fill the correct license plate!")}</div>
              {showErrorMessages && needsVehicleCheck === 1 && showRealLicensePlateFields && !licensePlate && (
                  <div className="text-red mt-2">{t("License plate number is required!")}</div>
              )}

            <div className="mb-6 mt-4">
                <input className="input-field w-full" type="text" placeholder={t('License plate number') || ''} value={licensePlate ?? ''} onChange={(e) => setLicensePlate(e.target.value)}/>
            </div>
              
              
              {isRealLicense === false && (
                <>
                    <div className="separator-line "></div>
                    <div className="text-light mb-4">
                        {t("Please upload a picture of the fake license plate!")}
                    </div>
                    
                    <ImageInput
                        images={correctLicensePlateImage}
                        setImages={setCorrectLicensePlateImage}
                        title={t("Take a photo")}
                        infoText={t("Confirmation photo")}
                        multiple={false}
                        required={isRealLicense === false}
                    />
                </>
              )}
              
          </> : <>
              <div className="mb-1 heading">
                  {t("Confirm the rider’s vehicle plate number?")}
              </div>
              {(showErrorMessages) && <div className="text-light mb-4 text-red">{t("Please choose an option!")}</div>}
              

              {displayFakeIdMessage && <div className="text-red text-center mb-4 card">
                  {t("Different plate number reported")}
              </div>}
              <div className="license-plate mt-6 mb-6">
                  {rider.licensePlate ?? "No license plate"}
              </div>

{/*
              <div className="flex flex-col justify-start items-start w-80">
                  <label className="checkbox mb-4">
                      <input
                          type="checkbox"
                          onChange={(e) => setIsRealLicense(e.target.checked)}
                          required
                          checked={isRealLicense === true}
                      />
                      <div className="checkbox__success-icon no-border see-through-background"></div>
                      <div className="checkbox__text text-white">{t("Yes")}</div>
                  </label>

                  <label className="checkbox mb-4">
                      <input
                          type="checkbox"
                          onChange={(e) => setIsRealLicense(true)}
                          required
                          checked={isRealLicense === false}
                      />
                      <div className="checkbox__success-icon no-border see-through-background"></div>
                      <div className="checkbox__text text-white">{t("No")}</div>
                  </label>
              </div>
*/}
                <div className="flex items-center gap-4 mb-2">
                    <RadioBtn
                        label={t("Yes")}
                        selected={isRealLicense === true}
                        onSelect={() => {
                            setIsRealLicense(true);
                            setShowErrorMessages(false);
                        }}
                        size='large'
                    />
                    <RadioBtn
                        label={t("No")}
                        selected={isRealLicense === false}
                        onSelect={() => {
                            setIsRealLicense(false);
                            setShowErrorMessages(false);
                        }}
                        size='large'
                    />
                </div>

                {isRealLicense === false && <>
                    <div className="separator-line mb-2"></div>
                    <ImageInput
                        images={licenseImage}
                        setImages={setLicenseImage}
                        title={t("Take a photo")}
                        infoText={t("Confirmation photo")}
                        multiple={false}
                        required={isRealLicense === false}
                    />
                </>}

              
          </>}

        <div className="flex gap-4 mt-8">
            
          <div className="flex-1">
            <button type="submit" className="button button--light w-full" disabled={!rider?.licensePlate} onClick={() => {
                if (showRealLicensePlateFields && rider.licensePlate) {
                    setShowRealLicensePlateFields(false);
                    return;
                }
                setStep((prev: number) => Math.max(prev - 1, 0));
                setProgressStep((prev: number) => Math.max(prev - 1, 0));

                navigate('/');
            }}>
              {t("Back")}
            </button>
          </div>

          <div className="flex-1">
            <button
                type="submit"
                className="button w-full"
                onClick={() => handleNext()}
            >
              {t("Next")}
            </button>
          </div>

        </div>

      </>
  );
};

export default VehicleVerificationStep;
